import React, { useState } from "react";
import TextInput from "@/components/forms/inputs/TextInput";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";

type SearchBarProps = {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
};

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search GPU Model"
}) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div className="flex-shrink-1 relative w-full">
      {isFocused ? null : (
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-dark-2200" />
      )}
      <TextInput
        name="gpu-search"
        placeholder={isFocused ? "" : placeholder}
        className={cn(
          "w-full rounded-[8px] px-3 py-2 placeholder:text-gray-dark-2200",
          isFocused ? "" : "pl-10"
        )}
        onChange={onChange}
        value={value}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
      />
    </div>
  );
};
